import React from "react";
import { Bookings } from "../components/bookings/index";

export const FortCollinsBookings = () => {
    return <Bookings location="Fort Collins" />;
};
